
export default {
  props: {
    visibale: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    okText: {
      type: String,
      default: "ok"
    },
    cancelText: {
      type: String,
      default: "cancel"
    }
  },
  data() {
    return {}
  },
  methods: {
    handleMask() {
      this.$emit("mask")
    },
    handleCancel() {
      this.$emit("cancel")
    },
    handleOk() {
      this.$emit("ok")
    }
  }
}
